import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const ReportsMenu = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div>
      <Button id="btnReports" onClick={() => navigate('/reports', { replace: true })}>
        {t('common.reports')}
      </Button>
    </div>
  )
}
export default ReportsMenu
